import { StorageService } from '../../services/storage.service';
import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { ObserverService } from '../../services/observer.service';


@Component({
    selector: 'app-settings-change-printer-paper-sizes',
    templateUrl: './settings-change-printer-paper-sizes.page.html',
    styleUrls: ['./settings-change-printer-paper-sizes.page.scss'],
})

export class SettingsChangePrinterPaperSizesPage implements OnInit {

    printer_paper_sizes = [];

    constructor(
        public modalController: ModalController,
        private storageService: StorageService,
        private observerService: ObserverService,
        private alertController: AlertController
    ) { }

    ngOnInit() {
        this.storageService.get("printer_paper_sizes").then((printer_paper_sizes) => {
            if (printer_paper_sizes) {
                this.printer_paper_sizes = printer_paper_sizes;
            }
        });
    }

    onPaperSizeChange(event, paper_size) {
        if(event.detail.checked) {
            if (!this.printer_paper_sizes.includes(paper_size)) {
                this.printer_paper_sizes.push(paper_size);
            }
        }
        else {
            const index = this.printer_paper_sizes.indexOf(paper_size);
            if(index !== -1) {
                this.printer_paper_sizes.splice(index, 1);
            }
        }
    }

    close() {
        this.modalController.dismiss();
    }

    update() {
        if(this.printer_paper_sizes.length) {
            this.storageService.set("printer_paper_sizes", this.printer_paper_sizes).then(() => {
                this.observerService.publish("printer_paper_sizes_changed", this.printer_paper_sizes);
                this.modalController.dismiss();
            });
        }
        else {
            this.storageService.remove("printer_paper_sizes").then(() => {
                this.observerService.publish("printer_paper_sizes_changed", null);
                this.modalController.dismiss();
            });
        }
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

}
